import Markdown from 'react-markdown';
import { slugifyHeading } from '@/utils/glossary-toc';

const ChevronDown = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const FaqItem = ({ item }) => {
  return (
    <details className="border-grey-200 group border-b">
      <summary className="text-grey-900 flex w-full cursor-pointer list-none items-center justify-between gap-4 py-5 text-left text-base font-semibold [&::-webkit-details-marker]:hidden">
        <span>{item.question}</span>
        <ChevronDown className="shrink-0 transition-transform duration-200 group-open:rotate-180" />
      </summary>
      <div className="text-grey-600 pb-5 text-[15px] leading-relaxed [&_strong]:font-bold">
        <Markdown>{item.answer || ''}</Markdown>
      </div>
    </details>
  );
};

const GlossaryFaq = ({ title, items = [] }) => {
  if (items.length === 0) return null;

  const headingId = title ? slugifyHeading(title) : undefined;

  return (
    <section>
      {title && (
        <h2 id={headingId} className="text-grey-950 mt-13 mb-5 text-[32px] leading-tight font-light">
          {title}
        </h2>
      )}
      <div>
        {items.map((item) => (
          <FaqItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default GlossaryFaq;
